import * as React from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import articles from '../../articles/articleIndex'

import './expandable_menu.scss'

export default function ExpandableMenu (props) {
  const [open, setOpen] = React.useState(false)

  const toggleDrawer = newOpen => () => {
    setOpen(newOpen)
  }

  const scrollTo = ref => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const DrawerList = (
    <Box
      sx={{ width: '100%' }}
      role='presentation'
      onClick={toggleDrawer(false)}
      className='expandable_menu'
    >
      <List>
        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <ListItemText primary='JUMP TO' sx={{ textAlign: 'center' }} />
          </ListItemButton>
        </ListItem>

        <Divider />

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/intro.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Introduction' />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => scrollTo(props.scrollToRef.experienceRef)}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/experience.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Experience' />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => scrollTo(props.scrollToRef.achievementRef)}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/achievement.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Achievements' />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => scrollTo(props.scrollToRef.educationRef)}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/education.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Education' />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => scrollTo(props.scrollToRef.projectRef)}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/project.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Project' />
          </ListItemButton>
        </ListItem>

        {articles.length > 0 && (
          <ListItem disablePadding className='menu_item'>
            <ListItemButton
              onClick={() => scrollTo(props.scrollToRef.articlesRef)}
            >
              <ListItemIcon>
                <img
                  src={process.env.PUBLIC_URL + '/images/project.svg'}
                  className='sections_icon'
                  alt=''
                />
              </ListItemIcon>
              <ListItemText primary='Articles' />
            </ListItemButton>
          </ListItem>
        )}

        <ListItem disablePadding className='menu_item'>
          <ListItemButton
            onClick={() => scrollTo(props.scrollToRef.contactRef)}
          >
            <ListItemIcon>
              <img
                src={process.env.PUBLIC_URL + '/images/contact.svg'}
                className='sections_icon'
                alt=''
              />
            </ListItemIcon>
            <ListItemText primary='Contact' />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  )

  return (
    <div>
      <Button onClick={toggleDrawer(true)}>
        <img
          src={process.env.PUBLIC_URL + '/images/menu_icon.svg'}
          className='menu_icon'
          alt=''
        />
      </Button>

      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          className: 'expandable_menu_paper',
          sx: {
            height: 'auto'
          }
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'transparent'
          }
        }}
      >
        {DrawerList}
      </Drawer>
    </div>
  )
}
